export const GREY_LIGHT = '#f3f3f3';
export const GREY_LIGHT_HIGHLIGHT = '#e6e6e6';
export const WHITE = 'white';
export const BLACK = 'black';
export const TURQOISE = '#007cbb';
export const TURQOISE_HIGHLIGHT = '#025986';



// WEBPACK FOOTER //
// ./src/constants/colours.js